import React, { useEffect, useMemo } from "react";
import { Grid } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import i18next from "i18next";
import EAAutoCompleteInput from "components/inputs/EAAutoCompleteInput";
import { SearchFormInputBloc } from "components/lists-advanced-search/SearchFormInputBloc/SearchFormInputBloc";
import { EVAllScorePerfomance } from "services/common/EcovadisUtils";

export function ThirdpartiesSearchEcovadis({ filters }) {
  const { control, setValue } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "ecovadis",
  });

  useEffect(() => {
    if (filters?.ecovadis) {
      filters.ecovadis?.forEach((filter) => {
        const fieldIndex = fields.findIndex((field) => field.score === filter.score);
        setValue(`ecovadis.${fieldIndex}.values`, filter.values || []);
      });
    }
  }, [fields, setValue, filters]);

  const ecovadisOptions = useMemo(() => {
    return Object.keys(EVAllScorePerfomance).map(score => ({
      label: i18next.t(`ecovadis.performance.${EVAllScorePerfomance[score]}`),
      value: score,
    }))
  }, [])

  return (
    <>
      {fields.map((field, index) => {
        return (
          <Grid item xs={4} sm={3} md={2} key={field.id}>
            <SearchFormInputBloc label={"Ecovadis " + i18next.t(`ecovadis.scores.${field.score}`)} hasTooltip>
              <EAAutoCompleteInput
                fieldName={`ecovadis.${index}.values`}
                options={ecovadisOptions}
                placeholder={i18next.t("all")}
                variant="outlined"
                multiple
                limitTags={1}
              />
            </SearchFormInputBloc>
          </Grid>
        );
      })}
    </>
  );
}
